import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RoleDetailResponse, RoleListDto, RoleResponse, UpdateRolePayload } from './roles.model';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private http = inject(HttpClient);
  private basePath = 'roles';

  findAll(filters: RoleListDto = {}): Observable<RoleResponse> {
    let params = new HttpParams();

    if (filters.page !== undefined) {
      params = params.set('page', filters.page.toString());
    }
    if (filters.limit !== undefined) {
      params = params.set('limit', filters.limit.toString());
    }
    if (filters.search) {
      params = params.set('search', filters.search);
    }
    if (filters.status) {
      params = params.set('status', filters.status);
    }

    return this.http.get<RoleResponse>(`/${this.basePath}`, { params });
  }

  // Create a new role (including optional modules)
  create(payload: any): Observable<any> {
    return this.http.post<any>(`/${this.basePath}`, payload);
  }

  getRoles(): Observable<{ data: any[]; total: number }> {
    let params = new HttpParams().set('limit', '100');
    return this.http.get<{ data: any[]; total: number }>(`/${this.basePath}`, { params });
  }

  checkNameUniqueness(name: string): Observable<{ available: boolean; role?: { name: string; id: string } }> {
    return this.http.get<{ available: boolean; role?: { name: string; id: string } }>(
      `/${this.basePath}/check-by-name?name=${encodeURIComponent(name)}`
    );
  }

  findOne(id: string): Observable<RoleDetailResponse> {
    return this.http.get<RoleDetailResponse>(`/${this.basePath}/${id}`);
  }

  updateFull(id: string, payload: UpdateRolePayload): Observable<RoleDetailResponse> {
    return this.http.patch<RoleDetailResponse>(`/${this.basePath}/${id}`, payload);
  }

  duplicate(id: string): Observable<RoleDetailResponse> {
    return this.http.post<RoleDetailResponse>(`/${this.basePath}/${id}/duplicate`, {});
  }

  delete(id: string): Observable<{ deleted: boolean }> {
    return this.http.delete<{ deleted: boolean }>(`/${this.basePath}/${id}`);
  }

}

